import * as angular from 'angular';
import { ISelfEmployedScope, IDeviceService } from './selfEmployed.types';
import { IGetAddformMetaResponseSelfEmployedSchema } from '../../../../../../shared/api/getAddformMeta';
import { patterns } from '../../../services/validationPatterns';
import { set } from 'lodash';
import { IAddFormService } from '../../../services/addFormService';
import { ISwitcherItem } from '../../../../../../shared/types/ui/switcher';
import validation from '../../../services/validation';
import { trackSelfEmployedSwitcherClick } from './selfEmployed.tracking';
import { get } from '../../../../../../shared/utils/functional/get';
import './selfEmployed.css';
const template = require('./selfEmployed.jade');

const SWITCHER_ITEMS: Array<ISwitcherItem> = [{
  value: true,
  text: 'Да, я уже самозанятый',

}, {
  value: false,
  text: 'Не указывать',
}];

const HINT_HTML = `
<p>С 1 января 2019 года сдавать квартиру легально можно всего за 4% от стоимости аренды и без походов в налоговую.</p>
<p>
  Если вы уже зарегистрированы как самозанятый, укажите это в объявлении, и мы выделим его в поиске.
  <a href="https://promo.cian.ru/nalog" target="_blank">Подробнее</a>
</p>
`;

// tslint:disable-next-line:no-default-export
export default angular
  .module('cian.addForm.selfEmployed', [])
  .directive('cianAfPriceAndDealTermsSelfEmployed', () => ({
    scope: {},
    controller: [
      '$scope',
      'addFormService',
      '$rootScope',
      'deviceService',
      'popupService',
      'dealRentService',
      'rentHelperService',
      'analyticsService',
      (
        $scope: ISelfEmployedScope,
        addFormService: IAddFormService,
        $rootScope: angular.IRootScopeService,
        deviceService: IDeviceService,
        popupService,
        dealRentService,
        rentHelperService,
        analyticsService,
      ) => {
        const { ad, form } = addFormService;

        $scope.isMobile = deviceService.isMobile;

        $scope.switcherItems = SWITCHER_ITEMS;
        $scope.hintHtml = HINT_HTML;
        $scope.ad = ad;
        $scope.form = form;
        $scope.pattern = patterns.numbers;

        $scope.openTooltipModal = () => {
          popupService.openPopup('hint', {
            text: HINT_HTML,
            title: 'Статус самозанятого',
            hideCloseButton: false,
          });
        };

        $scope.validation = validation(form, 'selfEmployedInn', {
          required: 'ИНН должен состоять из 12 цифр',
          minlength: 'ИНН должен состоять из 12 цифр',
          pattern: 'К вводу доступны только цифры',
        });

        $rootScope.$watch(
          () => addFormService.selfEmployed,
          (selfEmployed: IGetAddformMetaResponseSelfEmployedSchema) => {
            const inn = get(selfEmployed, 'inn');
            const isInnAvailable = get(selfEmployed, 'isInnAvailable');
            const errorMessage = get(selfEmployed, 'errorMessage');
            const message = get(selfEmployed, 'message');
            const isEditingDisabled = get(selfEmployed, 'isEditingDisabled');

            $scope.isInnAvailable = isInnAvailable;
            $scope.message = message;
            $scope.errorMessage = errorMessage;
            $scope.isEditingDisabled = isEditingDisabled;

            $scope.switcherItems = [ ...SWITCHER_ITEMS ].map((item) => {
              item.disabled = $scope.isEditingDisabled;

              return item;
            });

            const isEnabled = !!inn ? true : undefined;

            $scope.isSelfEmployed = isEnabled;

            if (isInnAvailable) {
              set(ad, 'selfEmployedData.inn', inn);
              set(ad, 'selfEmployedData.isEnabled', isEnabled);
            } else {
              delete ad.selfEmployedData;
            }
          },
          true,
        );

        $scope.disableSelfEmployed = () => {
          if (deviceService.isMobile) {
            form['selfEmployedEnabled'].$setViewValue(SWITCHER_ITEMS[1]);
          } else {
            form['selfEmployedEnabled'].$setViewValue(false);
          }
        };

        $scope.handleSwitcherChange = () => {
          const isEnabled = get(ad, 'selfEmployedData.isEnabled');

          $scope.isSelfEmployed = isEnabled;

          trackSelfEmployedSwitcherClick(isEnabled ? 'selfemployed' : 'non_selfemployed');
          if (isEnabled && rentHelperService.isDealRentAvailable()) {
            dealRentService.openSelfEmployedTrapPopup(
              analyticsService.trackDealRentTrapInFpBySelfEmployedClick
            );
          }
        };
      }],
    controllerAs: 'selfEmployedCtrl',
    template,
  }))
  .name;
